export var ApiCallStatus;
(function (ApiCallStatus) {
    ApiCallStatus[ApiCallStatus["Unattempted"] = 0] = "Unattempted";
    ApiCallStatus[ApiCallStatus["AwaitingCompletion"] = 1] = "AwaitingCompletion";
    ApiCallStatus[ApiCallStatus["Success"] = 2] = "Success";
    ApiCallStatus[ApiCallStatus["ValidationError"] = 3] = "ValidationError";
    ApiCallStatus[ApiCallStatus["AuthorizationError"] = 4] = "AuthorizationError";
    ApiCallStatus[ApiCallStatus["Failure"] = 5] = "Failure";
    ApiCallStatus[ApiCallStatus["ForbiddenError"] = 6] = "ForbiddenError";
    ApiCallStatus[ApiCallStatus["NotFoundError"] = 7] = "NotFoundError";
})(ApiCallStatus || (ApiCallStatus = {}));
//# sourceMappingURL=api.js.map